import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import {fieldsContains, fldComp} from '@/helpers'

Vue.use(Vuex)

const vueDataEl = document.getElementById('vue-data')
const vueData = vueDataEl ? JSON.parse(vueDataEl.text) : {}

function saveDealSorting({ field, type }) {
  localStorage.setItem('lkDealSortingField', field)
  localStorage.setItem('lkDealSortingType', type)
}

function saveExpressDealSorting({ field, type }) {
  localStorage.setItem('lkExpressDealSortingField', field)
  localStorage.setItem('lkExpressDealSortingType', type)
}

function saveDealFilter(filter) {
  localStorage.setItem('lkDealFilter', filter)
}

function saveExpressDealFilter(filter) {
  localStorage.setItem('lkExpressDealFilter', filter)
}

function saveDealSettingsFlag(flag, value) {
  const key = 'lkDealFlag_' + flag
  if (value) {
    localStorage.setItem(key, '1')
  } else {
    localStorage.removeItem(key)
  }
}

function saveExpressDealSettingsFlag(flag, value) {
  const key = 'lkExpressDealFlag_' + flag
  if (value) {
    localStorage.setItem(key, '1')
  } else {
    localStorage.removeItem(key)
  }
}

function saveDealStageFilter(filter) {
  localStorage.setItem('lkDealStageFilter', filter)
}

function saveExpressDealStageFilter(filter) {
  localStorage.setItem('lkExpressDealStageFilter', filter)
}

function getDealSettings() {
  return {
    field: localStorage.getItem('lkDealSortingField') || 'spec_num',
    type: localStorage.getItem('lkDealSortingType') || 'desc',
    filter: localStorage.getItem('lkDealFilter') || '',
    attentionRequired: !!localStorage.getItem('lkDealAttentionRequiredFilter'),
    hideClosed: !!localStorage.getItem('lkDealFlag_hideClosed'),
    manufacturePayment: !!localStorage.getItem('lkDealFlag_manufacturePayment'),
    stageFilter: localStorage.getItem('lkDealStageFilter') ?
      localStorage.getItem('lkDealStageFilter').split(',') :
      [],
  }
}

function getExpressDealSettings() {
  return {
    field: localStorage.getItem('lkExpressDealSortingField') || 'spec_num',
    type: localStorage.getItem('lkExpressDealSortingType') || 'desc',
    filter: localStorage.getItem('lkExpressDealFilter') || '',
    hideClosed: !!localStorage.getItem('lkExpressDealFlag_hideClosed'),
    manufacturePayment: !!localStorage.getItem('lkExpressDealFlag_manufacturePayment'),
    stageFilter: localStorage.getItem('lkExpressDealStageFilter') ?
      localStorage.getItem('lkExpressDealStageFilter').split(',') :
      [],
  }
}

function enrichDeals(deals) {
  deals.forEach(d => {
    d.total_leftover = {
      value: Math.max((d.invoice_leftover.value || 0) + (d.service_leftover.value || 0), 0),
      symbol: d.invoice_leftover.symbol,
    }
  })
  return deals
}

function applyDealFilters(deals, sorting, filter, stageFilter, hideClosed, manufacturePayment) {
  return (
    sorting.field === 'spec_num' ? (
      sorting.type === 'desc' ? deals : deals.slice().reverse()
    ) : sorting.field === 'manufacture' ? (
      deals.slice().sort(fldComp('manufacture', sorting.type === 'desc'))
    ) : deals
  ).filter(
    d => filter ?
      fieldsContains(d, ['title', 'spec_num', 'track_number', 'manufacture', 'stage', 'requisite', 'country'], filter) :
      true
  ).filter(
    d => stageFilter.length ?
      stageFilter.indexOf(d.stage_id) > -1 :
      true
  ).filter(
    d => hideClosed ?
      !(/(^|:)WON$/.test(d.stage_id) || /(^|:)LOSE$/.test(d.stage_id)) :
      true
  ).filter(
    d => manufacturePayment ?
      d.payment_to_manufacture :
      true
  )
}

const dealSettings = getDealSettings()
const expressDealSettings = getExpressDealSettings()

export default new Vuex.Store({
  state: {
    portalDomain: vueData.portalDomain,
    olWidgetUrl: vueData.olWidgetUrl,
    client: vueData.client,
    responsible: vueData.responsible,
    deals: null,
    expressDeals: null,
    dealDetails: {},
    dealStages: [],
    expressDealStages: [],
    unreadMessagesDeals: {},
    unreadMessagesTotal: 0,
    messengerOverlayOpened: false,
    lastMessages: {},
    news: null,
    selectedCells: [],
    dealSorting: {
      field: dealSettings.field,
      type: dealSettings.type,
    },
    expressDealSorting: {
      field: expressDealSettings.field,
      type: expressDealSettings.type,
    },
    defaultSortingTypes: {
      spec_num: 'desc',
      manufacture: 'asc',
    },
    dealFilter: dealSettings.filter,
    expressDealFilter: expressDealSettings.filter,
    dealStageFilter: dealSettings.stageFilter,
    expressDealStageFilter: expressDealSettings.stageFilter,
    dealHideClosed: dealSettings.hideClosed,
    expressDealHideClosed: expressDealSettings.hideClosed,
    dealManufacturePayment: dealSettings.manufacturePayment,
    expressDealManufacturePayment: expressDealSettings.manufacturePayment,
    showAppMenu: false,
    pageTitle: null,
    pageTitleLoading: false,
    pageReturnLink: null,
  },
  getters: {
    cellSum: state => state.selectedCells.reduce((sum, cell) => sum + cell.value, 0).toFixed(2),
    cellAvg: (state, getters) => ((getters.cellSum / state.selectedCells.length) || 0).toFixed(2),
    isCellSelected: state => ({ deal, field }) => {
      const index = state.selectedCells.findIndex(cell => cell.deal_id === deal.id && cell.field === field)
      return index > -1
    },
    sortedDeals: state => applyDealFilters(
      state.deals || [],
      state.dealSorting,
      state.dealFilter,
      state.dealStageFilter,
      state.dealHideClosed,
      state.dealManufacturePayment,
    ),
    sortedExpressDeals: state => applyDealFilters(
      state.expressDeals || [],
      state.expressDealSorting,
      state.expressDealFilter,
      state.expressDealStageFilter,
      state.expressDealHideClosed,
      state.expressDealManufacturePayment,
    ),
  },
  mutations: {
    setDeals(state, { deals }) {
      state.deals = enrichDeals(deals)
    },
    setExpressDeals(state, { deals }) {
      state.expressDeals = enrichDeals(deals)
    },
    setDealDetail(state, { dealId, detail }) {
      Vue.set(state.dealDetails, dealId, detail)
    },
    setDealStages(state, { stages }) {
      state.dealStages = stages
    },
    setExpressDealStages(state, { stages }) {
      state.expressDealStages = stages
    },
    setDealRequisites(state, { requisites }) {
      ;(state.deals || []).forEach(d => {
        Vue.set(d, 'requisite', requisites[d.id])
        if (state.dealDetails[d.id]) {
          Vue.set(state.dealDetails[d.id], 'requisite', requisites[d.id])
        }
      })
    },
    setExpressDealRequisites(state, { requisites }) {
      ;(state.expressDeals || []).forEach(d => {
        Vue.set(d, 'requisite', requisites[d.id])
      })
    },
    setUnreadMessagesDeals(state, { deals }) {
      state.unreadMessagesDeals = deals
    },
    setUnreadMessagesTotal(state, { total }) {
      state.unreadMessagesTotal = total
    },
    changeDealSorting(state, { field }) {
      const type = (
        state.dealSorting.field === field
          ? (state.dealSorting.type === 'desc' ? 'asc' : 'desc')
          : state.defaultSortingTypes[field]
      )
      state.dealSorting = { field, type }
      saveDealSorting({ field, type })
    },
    changeExpressDealSorting(state, { field }) {
      const type = (
        state.expressDealSorting.field === field
          ? (state.expressDealSorting.type === 'desc' ? 'asc' : 'desc')
          : state.defaultSortingTypes[field]
      )
      state.expressDealSorting = { field, type }
      saveExpressDealSorting({ field, type })
    },
    setDealSorting(state, { field, type }) {
      state.dealSorting = { field, type }
      saveDealSorting({ field, type })
    },
    setExpressDealSorting(state, { field, type }) {
      state.expressDealSorting = { field, type }
      saveExpressDealSorting({ field, type })
    },
    setDealFilter(state, { filter }) {
      filter = filter || ''
      state.dealFilter = filter
      saveDealFilter(filter)
    },
    setExpressDealFilter(state, { filter }) {
      filter = filter || ''
      state.expressDealFilter = filter
      saveExpressDealFilter(filter)
    },
    setDealStageFilter(state, { filter }) {
      filter = filter || []
      state.dealStageFilter = filter
      saveDealStageFilter(filter)
    },
    setExpressDealStageFilter(state, { filter }) {
      filter = filter || []
      state.expressDealStageFilter = filter
      saveExpressDealStageFilter(filter)
    },
    setDealHideClosed(state, { value }) {
      state.dealHideClosed = value
      saveDealSettingsFlag('hideClosed', value)
    },
    setExpressDealHideClosed(state, { value }) {
      state.expressDealHideClosed = value
      saveExpressDealSettingsFlag('hideClosed', value)
    },
    setDealManufacturePayment(state, { value }) {
      state.dealManufacturePayment = value
      saveDealSettingsFlag('manufacturePayment', value)
    },
    setExpressDealManufacturePayment(state, { value }) {
      state.expressDealManufacturePayment = value
      saveExpressDealSettingsFlag('manufacturePayment', value)
    },
    selectCell(state, { deal, field }) {
      if (!deal[field]) {
        return
      }

      const index = state.selectedCells.findIndex(cell => cell.deal_id === deal.id && cell.field === field)
      if (index > -1) {
        state.selectedCells.splice(index, 1)
      } else {
        state.selectedCells.push({
          deal_id: deal.id, field,
          value: deal[field].value,
        })
      }
    },
    setLastMessageText(state, { dealId, text }) {
      Vue.set(state.lastMessages, dealId, text)
    },
    setNews(state, { news }) {
      state.news = news
    },
    setShowAppMenu(state, { value }) {
      state.showAppMenu = value
    },
    setPageHeaderParams(state, { title, returnLink, loading = false }) {
      state.pageTitle = title
      state.pageTitleLoading = loading
      state.pageReturnLink = returnLink
    },
    toggleMessengerOverlay(state) {
      state.messengerOverlayOpened = !state.messengerOverlayOpened
    },
  },
  actions: {
    async getDeals({ commit }) {
      const { data: { deals } } = await axios.get('/api/deals/')
      await commit('setDeals', { deals })
    },
    async getExpressDeals({ commit }) {
      const { data: { deals } } = await axios.get('/api/express_deals/')
      await commit('setExpressDeals', { deals })
    },
    async getDealDetail({ commit }, { dealId }) {
      const { data: { deal } } = await axios.get('/api/deal_detail/', { params: { deal_id: dealId } })
      await commit('setDealDetail', { dealId, detail: deal })
    },
    async getDealStages({ commit }) {
      const { data: { stages } } = await axios.get('/api/deal_stages/')
      await commit('setDealStages', { stages })
    },
    async getExpressDealStages({ commit }) {
      const { data: { stages } } = await axios.get('/api/express_deal_stages/')
      await commit('setExpressDealStages', { stages })
    },
    async getDealRequisites({ state, commit }) {
      if (!state.deals || !state.deals.length) {
        await commit('setDealRequisites', { requisites: {} })
        return
      }
      const { data: { requisites } } = await axios.get('/api/deal_requisites/?ids=' + state.deals.map(d => d.id).join(','))
      await commit('setDealRequisites', { requisites })
    },
    async getExpressDealRequisites({ state, commit }) {
      if (!state.expressDeals || !state.expressDeals.length) {
        await commit('setExpressDealRequisites', { requisites: {} })
        return
      }
      const { data: { requisites } } = await axios.get('/api/deal_requisites/?ids=' + state.expressDeals.map(d => d.id).join(','))
      await commit('setExpressDealRequisites', { requisites })
    },
    async getUnreadMessages({ commit }) {
      const { data: { deals, total } } = await axios.post('/lk-messenger/api/get_unread_messages/')
      await commit('setUnreadMessagesDeals', { deals })
      await commit('setUnreadMessagesTotal', { total })
    },
    async getLastMessageText({ commit }, { dealId }) {
      const { data: { text } } = await axios.get('/api/last_message/', { params: { deal_id: dealId } })
      await commit('setLastMessageText', { dealId, text })
    },
    async getNews({ commit }) {
      const { data: { news } } = await axios.get('/api/get_news/')
      await commit('setNews', { news })
    },
    toggleMessengerOverlay({ commit }) {
      commit('toggleMessengerOverlay')
    },
  },
})
